var map = {
	"./24-knippen-thumb.jpg": 59,
	"./24-knippen/bg-thumb.jpg": 60,
	"./stichting-haarwensen-thumb.jpg": 61,
	"./wallpaper-thumb.jpg": 62,
	"./wallpaper2-thumb.jpg": 63,
	"./wallpaper9-thumb.jpg": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 133;